import { api, storage } from '../services';

async function getLead(email) {
  const response = await api.getLead(email);

  if (!response.ok) {
    return { success: false };
  }
  const {
    data: { attributes },
  } = response.data;
  const lead = {
    name: attributes.name,
    email: attributes.email,
    company: attributes.company,
    phone: attributes.phone,
  };

  storage.saveLead(lead);

  return { success: true, data: attributes };
}

export default getLead;
